var _circle, _circle2, _circle3, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOneToMany(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.334,
    cy: 11.666,
    r: 1.375,
    transform: "rotate(-90 12.334 11.666)",
    stroke: "currentColor",
    strokeWidth: 0.917,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.667,
    cy: 7.999,
    r: 1.375,
    transform: "rotate(-90 3.667 8)",
    stroke: "currentColor",
    strokeWidth: 0.917,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.334,
    cy: 4.333,
    r: 1.375,
    transform: "rotate(-90 12.334 4.333)",
    stroke: "currentColor",
    strokeWidth: 0.917,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.667 4.333H9.333C8.597 4.333 8 4.93 8 5.667v4.666c0 .737.597 1.334 1.333 1.334h1.334M5.333 8H8",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOneToMany);
export default __webpack_public_path__ + "static/media/one-to-many.c9171c2a8e739fa1f458b47e78736408.svg";
export { ForwardRef as ReactComponent };